// extracted by mini-css-extract-plugin
module.exports = {"routinecontent":"routine_routinecontent__yYMDg","wrapper":"routine_wrapper__pxz2o","addbag":"routine_addbag__sG2_z"};